import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { cn } from '@theprintbar/shared';
import { ComponentProps } from 'react';
import { OutlineButton } from '../Button';

interface CarouselPreviousButtonProps extends ComponentProps<typeof OutlineButton> {
	carouselKey?: string;
}

export const CarouselPreviousButton = ({ children, carouselKey, className, ...props }: CarouselPreviousButtonProps) => {
	return (
		<OutlineButton
			className={cn(className, `swiper-${carouselKey}-prev`)}
			id={`${carouselKey}-prev`}
			circle
			type="button"
			icon={() => <ArrowLeftIcon className="w-4 h-4" />}
			{...props}
		>
			{children}
		</OutlineButton>
	);
};
